<template>
    <div class="login_con">
        <!--        <nav-bar :navigationIndex="null" bgColor="#047E41" />-->
        <!--        <div style="height:125px"></div>-->
        <div class="flex_around">
            <div class="login_main">
                <div class="login_box">
                    <div class="login_title flex">
                        <div class="title_left flex_column">
                            <span>欢迎登录</span>
                        </div>
                    </div>
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
                        <el-tab-pane label="手机登录" name="phone"></el-tab-pane>
                        <el-tab-pane label="密码登录" name="password"></el-tab-pane>
                    </el-tabs>
                    <div class="login_input-label">账号</div>
                    <div class="login_input flex">
                        <el-icon color="#2567F1" style="font-size: 19px">
                            <Avatar />
                        </el-icon>
                        <input placeholder="请输入手机号" v-model.trim="formState.username" type="text"
                            @input="updateInput('username', $event)" />
                    </div>
                    <div class="login_input-label" v-show="activeName === 'password'">密码</div>
                    <div class="login_input flex" v-show="activeName === 'password'">
                        <el-icon color="#2567F1" style="font-size: 19px">
                            <Lock />
                        </el-icon>
                        <input placeholder="请输入密码" v-model.trim="formState.password"
                            :type="isPasswordVisible ? 'text' : 'password'" @input="updateInput('password', $event)" />
                        <el-icon class="cursor" style="font-size: 22px;" @click="viewPass(false)"
                            v-if="isPasswordVisible">
                            <Hide />
                        </el-icon>
                        <el-icon class="cursor" style="font-size: 22px;" @click="viewPass(true)" v-else>
                            <View />
                        </el-icon>
                    </div>
                    <div class="login_input-label" v-show="activeName === 'phone'">验证码</div>
                    <div v-show="activeName === 'phone'" style="display: flex">
                        <div class="login_input flex" style="width: 58%">
                            <el-icon color="#2567F1" style="font-size: 19px">
                                <Lock />
                            </el-icon>
                            <input placeholder="请输入验证码" v-model.trim="formState.code"
                                @input="updateInput('password', $event)" />
                        </div>
                        <div class="login_input flex hqyzm" @click="codeDis ? '' : getCode()">{{ codeText }}</div>
                    </div>
                    <div class="login_btn" @click="loginSuccess()">
                        <button>登 录</button>
                    </div>
                    <div class="flex_between" v-show="activeName === 'password'">
                        <div class="cursor">
                            <div class="color_000" @click="goPage('/resetPasswordPage')">
                                <div>忘记密码</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { login, sendMsg, userInfo } from "@/utils/api";
// @ is an alias to /src

export default {
    name: 'loginPage',
    components: {

    },
    data() {
        return {
            codeDis: false,
            codeText: '获取验证码',
            time: 60,
            activeName: 'phone',
            isLogin: false,
            // navigationIndex: 0
            formState: {
                username: '',
                password: '',
            },
            isPasswordVisible: false,
        };
    },
    mounted() {
        // console.log(this.navigationIndex);
    },
    methods: {
        // 获取验证码
        getCode() {
            if (this.formState.username == '' || this.formState.username == null) {
                this.$message.error('手机号不能为空');
                return;
            }
            sendMsg({ phone: this.formState.username }).then((res) => {
                if (res.code == 200) {
                    let timer = setInterval(() => {
                        this.codeDis = true;
                        this.codeText = this.time + 's后重新获取';
                        if (this.time > 0) {
                            this.time--;
                        } else {
                            this.codeDis = false;
                            this.codeText = '获取验证码';
                            this.time = 60;
                            clearInterval(timer);
                        }
                    }, 1000);
                }
            })
        },
        // 检测输入框格式
        updateInput(field, event) {
            this.formState[field] = event.target.value.replace(/\s+/g, '');
        },
        // 查看密码
        viewPass(isPassword) {
            // console.log(isPassword);
            this.isPasswordVisible = isPassword;
        },
        // 登录
        loginSuccess() {
            if (this.formState.username == '' || this.formState.username == null) {
                this.$message.error('手机号不能为空');
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.formState.username)) {
                this.$message.error("手机号码有误，请重填");
                return;
            }
            if (this.formState.password == '' || this.formState.password == null) {
                this.$message.error('请输入密码');
                return;
            }
            if (this.activeName === 'phone') {
                if (this.formState.code == '' || this.formState.code == null) {
                    this.$message.error('请输入验证码');
                    return;
                }
            }
            login({ phonenumber: this.formState.username, code: this.formState.password }).then((res) => {
                if (res.code == 200) {
                    localStorage.token = res.token;
                    this.$message.success('登录成功');
                    this.getUserInfo();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getUserInfo() {
            userInfo().then((res) => {
                if (res.code == 200) {
                    localStorage.userName = res.user.userName;
                    localStorage.userId = res.user.userId;
                    localStorage.authFlag = res.authFlag;
                    localStorage.userType = res.user.userType;
                    this.$router.push("/");
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        goPage(path) {
            this.$router.push({
                path: path
            });
        }
    }
}
</script>

<style scoped lang="scss">
.login_con {
    height: 100vh;
    // background: url("@/assets/images/regBg.jpg") no-repeat center;
    background-size: 100% auto;
    background-position: center;
}

.login_main {
    position: fixed;
    top: 50%;
    left: 59.5%;
    transform: translate(0, -50%);
    width: 460px;
    background-color: #ffffff;
    // box-shadow: 0 0 16px 2px rgba(19, 128, 56, .6);
    border-radius: 5px;
}

.login_box {
    padding: 49px 40px 40px 45px;
}

.login_title {
    font-size: 33px;
    color: #333333;
    line-height: 50px;
    font-family: SOURCEHANSANSCN-BOLD;
    display: flex;
    align-items: baseline;
    font-weight: bold;
    position: relative;
    margin-left: 14px;
    margin-bottom: 26px;

    &::before {
        position: absolute;
        left: -16px;
        bottom: 9px;
        width: 5px;
        height: 24px;
        content: '';
        background: linear-gradient(0deg, #015EEA 0%, #00C0FA 100%);
    }
}

.login_line {
    width: 50px;
    height: 4px;
    background: #11672e;
    border-radius: 2px;
    margin-top: 3px;
}

.title_right {
    font-size: 15px;
    font-weight: 400;
    color: #aeaeae;
    margin-left: 5px;
    margin-bottom: 10px;
}

.login_input-label {
    margin-top: 18px;
    font-size: 18px;
    margin-bottom: 7px;
}

.login_input {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 35px;
    padding: 0 10px;
    font-size: 40px;
}

.hqyzm {
    font-size: 15px;
    flex: 1;
    border: 1px solid #2567F1;
    margin-left: 3%;
    color: #2567F1;
    justify-content: center;
    cursor: pointer;
}

.login_input input {
    border: none;
    color: #606266;
    height: 100%;
    font-size: 15px;
    margin: 0;
    padding: 0;
    padding-left: 10px;
    width: 250px;
    margin-right: 20px;
}

.code_box {
    margin-top: 20px;
}

.code_input {
    width: 50%;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 35px;
    padding: 0 10px;
}

.code_box img {
    width: 40%;
    height: 35px;
    background-color: #11672e;
}

.forgot_psw_box {
    // margin: 5px 0;
    color: #00AC64;
    font-size: 14px;
}

.login_btn button {
    width: 100%;
    height: 50px;
    color: #fff;
    background-color: #2567F1;
    border: none;
    border-radius: 4px;
    margin-top: 62px;
    margin-bottom: 15px;
    font-size: 22px;
    font-family: SOURCEHANSANSCN-REGULAR;
}

.cursor {
    color: #2567F1;
    font-size: 14px;
}

.title-content {
    color: #626262;
    font-size: 20px;
    font-family: SOURCEHANSANSCN-BOLD;
    line-height: 22px;
    margin-top: 15px;
    margin-bottom: 10px;
}

.title_left {
    display: flex;
    justify-content: start;
}

:deep .login_input {
    height: 50px;
    border: 2px solid #999999;
    border-radius: 7px;
}

.color_000 {
    color: #2567F1;
}

::v-deep .el-tabs__item {
    font-size: 20px;
    line-height: 50px;
    height: 50px;
}

::v-deep .el-tabs {
    width: 78%;
    margin: auto;
}

// .get-code{
//     width: 40%;
//     height: 30px;
//     border-radius: 4px;
//     // border: 1px solid #00AC64;
//     background-color: #00AC64;
//     text-align: center;
//     line-height: 30px;
//     color: #fff;
//     border: none;
// }</style>
